import { useRef } from "react";
import { motion, useInView } from "framer-motion";

export default function FadeUp({ children, delay = 0, y = 28, className = "", style = {} }) {
  const ref = useRef(null);
  const visible = useInView(ref, { once: true, margin: "-60px" });

  return (
    <motion.div
      ref={ref}
      className={className}
      style={style}
      initial={{ opacity: 0, y }}
      animate={visible ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.72, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}
